import { TABS, type TabId } from '../types';
import { useAuth } from '../hooks/useAuth';

type Props = {
  active: TabId;
  onChange: (id: TabId) => void;
  /** Chat is the one tab gated on data as well as role: admins always, a
   *  franchisee only once chat is switched on for their AF. */
  chatOn?: boolean;
};

export default function Tabs({ active, onChange, chatOn }: Props) {
  const { user } = useAuth();
  const visible = TABS.filter((t) => {
    if (t.id === 'tab-chat') return user?.role === 'admin' || chatOn === true;
    return !t.roles || (user && t.roles.includes(user.role));
  });

  return (
    <nav className="tab-nav">
      {visible.map((t) => (
        <button
          key={t.id}
          className={`tab-btn ${active === t.id ? 'is-active' : ''}`}
          onClick={() => onChange(t.id)}
          disabled={!t.ready}
          title={t.ready ? '' : 'Not yet ported'}
        >
          {t.label}
          {!t.ready && <span className="tab-stub-badge">soon</span>}
        </button>
      ))}
    </nav>
  );
}
